exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".AOi2XC6lvu_G3yWbqp3cp{background-color:#dff0d8;color:#3c763d;display:table}._1YNfQOIv76taPRcv9BPyPV{background-color:#f2dede;color:#a94442;display:table;text-decoration:line-through}.fXbgLdpI6e0hJaa9X_ucI{background-color:#d9edf7;color:#31708f;display:table;text-decoration:line-through}._2AmJJHZC9mCUHvAaXQaAtk{font-family:monospace}", ""]);

// exports
exports.locals = {
	"added-fields": "AOi2XC6lvu_G3yWbqp3cp",
	"removed-fields": "_1YNfQOIv76taPRcv9BPyPV",
	"mutated-fields": "fXbgLdpI6e0hJaa9X_ucI",
	"field-value": "_2AmJJHZC9mCUHvAaXQaAtk"
};


//////////////////
// WEBPACK FOOTER
// ../graylog2-server/graylog2-web-interface/~/css-loader!../graylog2-server/graylog2-web-interface/src/components/search/ChangedMessageField.css
// module id = 519
// module chunks = 0